<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formOrder">
        <div class="row">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
              (onClick)="printPage()"></app-custom-button>
            <!-- Adjuntar archivos -->
            <app-custom-button [title]="'Adjuntar archivos'" [icon]="'pi pi-paperclip'" [severity]="'contrast'"
              (onClick)="openAttachFile()"></app-custom-button>
            <app-custom-modal #attachFileOrder [header]="'Adjuntar archivos'" [children]="componentAttachFiles"
              [closable]="true" [width]="'40vw'" [inputs$]="inputsForAttachFiles$" [output$]="outputForAttachFiles$"
              hidden></app-custom-modal>
            <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
              (onClick)="deleteOrder()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewOrder()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="orderContract.userNameCreate"
              [createDate]="orderContract.createDate" [userNameUpdate]="orderContract.userNameUpdate"
              [updateDate]="orderContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <!-- Formulario Captura -->
        <div class="row mt-1 d-flex justify-content-between capture-columns">
          <div class="col-lg-7 md-12 col-sm-12 col-12">
            <div class="row">
              <div class="col-lg-4 col-md-3 col-sm-3 col-12">
                <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [required]="true"
                  [recovery]="true" [list]="listBranches"
                  (onChangeSelect)="getBranch($event, true)"></app-custom-select>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-12">
                <app-custom-input-number formControlName="consecutive" [required]="true" [recovery]="true"
                  [labelText]="'Número'" (onChangeNumber)="changeConsecutive()">
                </app-custom-input-number>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-12">
                <app-custom-select formControlName="orderTypeId" [labelText]="'Tipo'" [required]="true"
                  [list]="listTypes" (onChangeSelect)="changeType($event)">
                </app-custom-select>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-12">
                <app-custom-input-text formControlName="purchaseOrderNumber" [labelText]="'Nro.O.Compra'"
                  [maxLength]="15">
                </app-custom-input-text>
              </div>
              <div class="col-lg-2 col-md-3 col-sm-3 col-12">
                <app-custom-datepicker formControlName="dateOrder" [labelText]="'Fecha'" [required]="true"
                  (onChangeDate)="changeDate($event)">
                </app-custom-datepicker>
              </div>
              <div class="col-lg-6 col-md-3 col-sm-6 col-12">
                <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [required]="true"
                  [list]="listClients" (onChangeSelect)="getClient($event)">
                </app-custom-autocomplete>
              </div>
              <div class="col-lg-6 col-md-3 col-sm-6 col-12">
                <app-custom-autocomplete formControlName="costCenterId" [labelText]="'C.Costos'" [required]="true"
                  [list]="filteredCostCenters"
                  (onChangeSelect)="getCostCenter($event, false)"></app-custom-autocomplete>
              </div>
              <div class="col-lg-6 col-md-3 col-sm-6 col-12">
                <app-custom-autocomplete formControlName="sellerId" [labelText]="'Vendedor'" [required]="true"
                  [list]="listSellers" (onChangeSelect)="getSeller($event, true)"></app-custom-autocomplete>
              </div>
              <div class="col-lg-6 col-md-3 col-sm-6 col-12">
                <app-custom-input-text formControlName="advertiser" [labelText]="'Anunciante'" [maxLength]="70">
                </app-custom-input-text>
              </div>
            </div>
          </div>
          <div class="col-lg-5 md-12 col-sm-12 col-12">
            <div class="row  align-items-end flex-nowrap">
              <div class="col-lg-4 col-md-3 col-sm-4 col-4">
                <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-4 col-4 d-flex align-items-end gap-1">
                <app-custom-button [icon]="iconState" [title]="titleState" [severity]="'primary'"
                  [disabled]="disableState" (onClick)="changeState()"></app-custom-button>
                <app-custom-button [icon]="'pi pi-undo'" [title]="'Reversar estado'" [severity]="'success'"
                  [disabled]="disableReverseState" (onClick)="revertState()"></app-custom-button>
                <app-custom-button [title]="'Anular pedido'" [icon]="'pi pi-ban'" [severity]="'warn'" [disabled]="false"
                  (onClick)="openAnnulOrderModal()"></app-custom-button>
                <app-custom-modal #annulOrderModal [label]="'Anular Pedido'" [width]="'25rem'"
                  [header]="'Anular Pedido'" [inputs$]="inputsForAnnulOrderModals$"
                  [children]="componentAnnulOrderModal" (params)="reloadOrder($event.reload)" hidden>
                </app-custom-modal>
              </div>
              <div class="col-lg-5 col-md-6 col-sm-4 col-4">
                <div *ngIf="quotationConsecutive !== ''" class="d-flex justify-content-end animate-fade-in"
                  style="min-width: 0;">
                  <app-custom-chip
                    [link]="orderContract.quotationId ? ['/quotation/register', orderContract.quotationId] : null"
                    tooltip="Ver cotización" [label]="'Cotización única: ' + quotationConsecutive" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-4 col-sm-6 col-12">
                <app-custom-textarea formControlName="observation" [labelText]="'Observación Técnica'"
                  [autoResize]="false" [rows]="1" [maxLength]="250"></app-custom-textarea>
              </div>
              <div class="col-lg-6 col-md-4 col-sm-6 col-12">
                <app-custom-textarea formControlName="observationCommercial" [labelText]="'Observación Comercial'"
                  [autoResize]="false" [rows]="1"></app-custom-textarea>
              </div>
              <div class="col-lg-12 col-md-4 col-sm-12 col-12">
                <app-custom-textarea formControlName="observationRemission" [labelText]="'Observación Remisión'"
                  [autoResize]="false" [rows]="1" [maxLength]="250"></app-custom-textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-12 d-flex justify-content-end">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="isSaveDisabled"
              [variant]="undefined" (onClick)="send()"></app-custom-button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-order-detail [orderModel]="orderContract" [disableAllDetail]="disableAllDetail"
      [disablePartial]="disablePartial" [permissionUpdatable]="permissionUpdatable" [permissionsUser]="permissionsUser"
      [userAuthenticated]="userAuthenticated" [isCreatingOrderFromQuotation]="isCreatingOrderFromQuotation"
      [swMandatoryQuotation]="swMandatoryQuotation" [disableOrderFromQuotation]="disableOrderFromQuotation"
      [swReservation]="swReservation" [swQuotation]="swQuotation" [swShowOnlyOrderBreakdown]="swShowOnlyOrderBreakdown"
      (emitQuantityDetails)="quantityDetails = $event" (orderId)="getNewOrder($event)">
    </app-order-detail>
  </div>
</section>
<!-- Impresión -->
<app-print-order id="print-order" [companyId]="companyId" [reloadPrint]="reloadPrint"
  [orderPrintModel]="orderPrintModel" [focusText]="false" [editFormat]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-order>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>